import { ApiSingleModelResponse, V2 } from 'types/swagger/clarifai-api';
import { useQuery } from 'react-query';
import { getModel } from '../getModel';

export const useGetModel = (
  args: { params: Partial<V2.V2GetModel.RequestParams>; query: V2.V2GetModel.RequestQuery },
  initialData?: ApiSingleModelResponse,
) => {
  return useQuery(
    ['V2GetModel', args],
    () =>
      getModel({
        params: args.params as V2.V2GetModel.RequestParams,
        query: args.query,
      }),
    {
      initialData,
      // Enhanced caching configuration
      staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // 30 minutes - cache persists for 30 minutes
      enabled: Boolean(args.params.userAppIdUserId && args.params.userAppIdAppId && args.params.modelId),
    },
  );
};
